import React, { useEffect, useState } from 'react';
import { ShoppingBag } from 'react-feather';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Loader } from '../../components/Loader';
import { FeatherButton } from '../../components/FeatherButton';
import { ensure } from '../../constants';
import * as actions from "../../redux/ensure";
import { Credits } from '../../components/Credits';
import { StoreDetails } from './StoreDetails';
import BackButton from '../../components/BackButton';

const Store = props => {
    useEffect(() => {
        props.ensure(ensure.products + ensure.smsCredits);
    }, []);

    const [item, setItem] = useState(null);

    const renderProducts = () => {
        return !props.products ? null : <div className="nc-table-wrapper">
            <table className='table table-striped nc-table'>
                <thead>
                    <tr>
                        <th>Number of credits</th>
                        <th>Price</th>
                        <th>Cost per credit</th>
                        <th>Add to cart</th>
                    </tr>
                </thead>
                <tbody>
                    {props.products.map(p =>
                        <tr key={p.id}>
                            <td>{p.name}</td>
                            <td>${p.price} {props.paysGst ? ' + GST' : ''}</td>
                            <td>{((p.price * 100) / p.smsCredits).toFixed(1).replace('.0', '')}c</td>
                            <td><FeatherButton feather={<ShoppingBag />} onClick={() => setItem(p)} /></td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    }

    return (
        <div>
            <Loader loading={props.loading}>
                <BackButton />
                <Credits smsCredit={props.smsCredit} hideButton={true} />
                <div className="nc-title">Buy SMS credits</div>
                {renderProducts()}
                {item && <StoreDetails item={item} paysGst={props.paysGst} />}
            </Loader>
        </div>
    );
}

const mapStateToProps = ({ ensure }) => ({
    products: ensure.products,
    smsCredit: ensure.smsCredit,
    loading: ensure.ensureLoading,
    error: ensure.ensureError,
    paysGst: ensure.paysGst
});

export default connect(mapStateToProps, actions)(withRouter(Store));


// WEBPACK FOOTER //
// ./src/pages/Store/Store.js